import { getData, postData } from "../../api";

export const getAllData = async () => {
  try {
    let url = `/chat/chat`;

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const getAllChats = async (id) => {
  try {
    let url = `/chat/chat/get/${id}`;

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const sendMessageApi = async (id, data) => {
  try {
    return await postData(`/chat/chat/send-message/${id}`, data);
  } catch (error) {
    console.error(error);
  }
};

